import ActionTableBlock from '../components/action-table';
export default ActionTableBlock;
